import { Block } from 'webiq.boilerplate'
import CheckoutPaymentGiftcard from '../checkout-payment-giftcard'
import BlockFactory from 'webiq.boilerplate/scripts/support/BlockFactory'

export default class CheckoutPayment extends Block {
	static title = 'checkout-payment'

	init() {
        this.paymentSelect = this.getElement("payment-methods")
        this.paymentImage = this.getElement("payment-image")
        this.giftcardAddInput = this.getElement("giftcard-add")
        this.giftcardApply = this.getElement("giftcard-apply")
        this.giftcardsContainer = this.getElement("giftcards-container")
		this.checkoutTotal = this.getElement('total')
		this.productData = this.getElement('ga4')

		if (this.paymentSelect) {
            this.paymentSelect.addEventListener('sl-change', (e) => {
                const currentOption = e.currentTarget.querySelector('[aria-selected="true"]')
                this.paymentImage.src = currentOption.dataset.img
            })
        }

        this.giftcardApply.addEventListener("click", () => {
            this.AddGiftcard(this.giftcardAddInput.value)
        })

		let ga4Data = null
		try {
			ga4Data = JSON.parse(this.productData.innerHTML)
		} catch(e) {
			if (process.env.NODE_ENV === 'development') {
				// eslint-disable-next-line no-console
				console.error(e)
			}
		}
		
		this.element.addEventListener('submit', () => {
			if (ga4Data) {
				let productsArray = []
				ga4Data.shoppingcart_products.forEach((item) => {
					const product = {
						item_id: item.item_id,
						item_group_id: item.row_id,
						item_name: item.item_name,
						item_brand: item.item_brand,
						item_category: item.item_category,
						item_variant: item.item_variant,
						price: item.price,
						price_user: item.price_user,
						quantity: item.quantity,
						google_business_vertical: "retail",
						id: item.id,
					}
					productsArray.push(product)
				})
	
				const eurValue = (parseFloat(this.element.getAttribute('data-total')) / parseFloat(this.element.getAttribute('data-exchange-rate'))).toFixed(2)
	
				if ('dataLayer' in window) {
					window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
					window.dataLayer.push({
						shoppingcartId: parseInt(document.querySelector('input[name="analytics-id"]').value),
						event: 'begin_checkout',
						ecommerce: {
							currency: "EUR",
							currency_user: this.element.getAttribute('data-currency') ? this.element.getAttribute('data-currency') : "EUR",
							value: parseFloat(eurValue),
							value_user: parseFloat(this.element.getAttribute('data-total')),
							items: productsArray,
						},
					})
				}
			}
		})

		window.eventEmitter.on('giftcardadd:disable', () => {
			this.giftcardAddInput.disabled = true
		})

		window.eventEmitter.on('giftcardadd:enable', () => {
			this.giftcardAddInput.disabled = false
		})

		window.eventEmitter.on('total:refresh', (data) => {
			this.checkoutTotal.innerHTML = data.total
		})
	}

    AddGiftcard($giftcard) {
		if ($giftcard == "") {
			return
		}
		this.giftcardAddInput.querySelector('sl-spinner').classList.remove('tw-hidden')
		this.giftcardAddInput.disabled = true
		window.eventEmitter.emit('paymentgiftcard:disable')
        const payload = new FormData()
		payload.append('giftcard', $giftcard)
		payload.append('giftcard_add', true)
		payload.append('ajax', true)

		fetch('/checkoutgiftcard', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then((response) => response.json())
			.then((json) => {
				if (!json.error) {
					this.giftcardsContainer.innerHTML = json.html
					this.checkoutTotal.innerHTML = json.total
					
                	this.bindGiftcardsEvent()
					this.resetGiftcardField()
				} else {
					window.eventEmitter.emit('product:add-fail', {error: json.error_message})
					this.resetGiftcardField()
				}
			})
			.catch((error) => {
                console.log(error)
            })
    }

    bindGiftcardsEvent() {
		this.element
			.querySelectorAll('.checkout-payment-giftcard')
			.forEach((element) => {
				BlockFactory.create(CheckoutPaymentGiftcard, element, false)
			})
	}

	resetGiftcardField() {
		this.giftcardAddInput.value = ""
		this.giftcardAddInput.querySelector('sl-spinner').classList.add('tw-hidden')
		this.giftcardAddInput.disabled = false
		window.eventEmitter.emit('paymentgiftcard:enable')
	}
}
